import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog1() {
  pageTitle('The True Cost of Solar: Why Initial Investment Leads to Long-Term Savings');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add email functionality here
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    
    // Send to company email
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="The True Cost of Solar: Why Initial Investment Leads to Long-Term Savings"
        variant="text-center"
        shape="shape_5"
        category="Solar Energy"
        date="15 Jun 2024"
        avatar="Financial Analysis"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Solar Investment Analysis"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Breaking Down the Economics of Solar Installation: A 10-Year Financial Perspective
          </h3>
          <p>
            Many homeowners hesitate at the initial cost of solar installation, but the long-term financial benefits far outweigh the upfront investment. Our comprehensive analysis shows that most systems pay for themselves within 5-7 years.
          </p>
          <p>
            With current energy prices rising at 3-5% annually, solar installation isn't just an environmental choice—it's a smart financial decision that can save households an average of $20,000 over ten years.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Solar Installation"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Energy Savings"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Financial Benefits"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Understanding Your Return on Investment</h3>
          <p>
            Our clients consistently report 40-60% reductions in their monthly energy bills after installing solar systems. Combined with government incentives and tax rebates, the financial benefits become even more compelling.
          </p>
          <blockquote>
            "After installing solar panels through Soketry Solutions, our monthly energy bill dropped from $300 to just $75. The system will pay for itself in just 4 years!"
            <small>James Anderson, Homeowner</small>
          </blockquote>
          <p>
            With Soketry Solutions' flexible financing options and expert installation services, transitioning to solar has never been more accessible or financially prudent.
          </p>
          <ul>
            <li>Average monthly savings of $150-$250</li>
            <li>Property value increase of 4-6%</li>
            <li>25-year warranty on all installations</li>
            <li>Government incentives covering up to 30% of costs</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Solar Investment
            </a>
            <a href="/" className="cs_category">
              Financial Planning
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on solar investment"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 